/**
 * Column folding shared by WidgetList and DataList: a column with `foldBelow` leaves the row line
 * once the measured list width drops under that value. Kept in its own module because WidgetList
 * imports from DataList, so DataList cannot import from WidgetList without a cycle.
 */

/** Keys of the columns folded away at the given list width (none until the width is measured). */
export const getFoldedColumnKeys = (
  columns: { key: string; foldBelow?: number }[],
  listWidth: number | undefined
): Set<string> =>
  new Set(
    listWidth === undefined
      ? []
      : columns.filter((column) => column.foldBelow !== undefined && listWidth < column.foldBelow).map((c) => c.key)
  );
